import { Row } from "./Row";
interface IProsp {
  isShow: boolean;
  onToggle: () => void;
}

export const ExercisingYourRights = ({ onToggle, isShow }: IProsp) => {
  return (
    <Row title="Exercising Your Rights" onToggle={onToggle} isShow={isShow}>
      <div>
        <div className="font-bold">
          a. General Policy Regarding Exercising Your Rights
        </div>
        <div className="mt-2">
          If you would like to access the personal information we have collected
          about you to correct or update it, and you are a Medcursor user, you
          have the ability to log into a mobile application and make the
          corrections to the personal information in your account profile.
          Alternatively, or if you need assistance, please contact us by one if
          the means described in Section 11, and someone on our support team
          will assist you correct or update your personal information.
        </div>

        <div className="mt-4">
          Please keep in mind that in unusual circumstances we may have a legal
          right or obligation to preserve personal information as it currently
          exists. If we do not amend personal information about you upon your
          request, we will communicate with you concerning the reason.
        </div>

        <div className="mt-4">
          If you wish to opt out of or stop receiving any marketing
          communications from us, please contact us at one of the mechanisms
          listed in Section 11. Any email communications from us contain
          instructions on opting out of further email communications.
          Nonetheless, even if you opt out of marketing communications, we will
          still contact you regarding support, administration, and security of
          our services and products. You can always choose not to provide
          information, though not providing such information may mean that you
          may be unable to make a purchase or to take advantage of certain
          features of our services.
        </div>
        <div className="font-bold mt-4">b. Identity Verification</div>
        <div className="mt-2">
          Medcursor has an obligation to verify the identity of any individual or
          authorized agent seeking to exercise rights under the California
          Consumer Privacy Act (CCPA).
        </div>
        <div className="mt-4">
          For California residents with a password-protected account with
          Medcursor accessible via a mobile application, we can verify your
          identity by having you access your account and complete a form to
          submit a request for your rights or confirm that you made a request.
        </div>

        <div className="mt-4">
          For California residents that do not have an account with Medcursor :
        </div>
        <ul className="list-disc pl-8 mt-2 text-gray666 dark:text-white60">
          <li>
            We will verify your identity in response to a request to exercise
            your individual rights by requiring that you to provide two pieces
            of information that we already have on file with you, which may
            include:
          </li>
          <li>oItems of contact information, or</li>
          <li>oContent of communications you sent to us.</li>
          <li>
            In addition, in the case of a request for specific pieces of
            personal information, we will ask for an additional piece of
            information that we may have in addition to the two pieces requested
            above, together with a signed declaration under penalty of perjury
            that the requestor is the consumer whose personal information is the
            subject of the request or an authorized agent acting on behalf of
            that consumer.
          </li>
        </ul>

        <div className="mt-4">
          An authorized agent seeking to exercise rights on behalf of an
          individual California resident must prove the agent’s authority either
          by providing a power of attorney pursuant to Probate Code sections
          4121 to 4130 or by:
        </div>
        <ul className="list-disc pl-8 mt-2 text-gray666 dark:text-white60">
          <li>
            Providing a copy of a writing signed by the resident giving the
            agent permission to act on the resident’s behalf;
          </li>
          <li>
            Verification of the authorized agent’s own identity under the
            procedures in this section; and/or
          </li>
          <li>
            Communicating with the California resident directly to confirm the
            status of the agent as being authorized to act on behalf of the
            resident.
          </li>
        </ul>

        <div className="mt-4">
          We will not provide or delete information as requested if we are
          unable to verify the identity of the requestor as required above, if
          an agent cannot prove authority to act on behalf of an individual, or
          we have reason to believe that the request is fraudulent. We may ask
          for additional verification if we suspect fraud, such as a copy of an
          identification credential from the requestor. We will use any such
          additional information strictly for identity verification purposes,
          and it will be deleted following the completion of the verification
          process. We may, however, retain any information needed to comply with
          the CCPA or other applicable law.
        </div>
      </div>
    </Row>
  );
};
